import React, { useEffect, useState } from 'react';
import ExpenseCategoriesListing from './ExpenseCategoriesListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setIsOpenEditDialog, setPage, setRowsPerPage, setSearchValue, setIsTableLoading, setItems, setTotalItems } from 'src/redux/slices/ExpenseCategoriesSlice';
import AddExpenseCategoriesWrapper from '../Add/AddExpenseCategoriesWrapper';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import EditExpenseCategoriesWrapper from '../Edit/EditExpenseCategoriesWrapper';
import { useChangeStatusExpenseCategoriesByIdMutation, useDeleteExpenseCategoriesByIdMutation, useGetAllExpenseCategoriesDataQuery } from 'src/services/ExpenseCategoriesService';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const ExpenseCategoriesListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, isOpenAddDialog, isOpenEditDialog, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.expenseCategories);
  const [selectedExpenseCategoriesId, setSelectedExpenseCategoriesId] = useState<string>()
  const [deleteExpenseCategories] = useDeleteExpenseCategoriesByIdMutation()
  const [changeStatusExpenseCategories] = useChangeStatusExpenseCategoriesByIdMutation()
  const { data, isLoading, isFetching } = useGetAllExpenseCategoriesDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "expenseCategoryName",
    ],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const handleDeleteExpenseCategories = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to delete this ExpenseCategories ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          deleteExpenseCategories(row).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const handleChangeStatusExpenseCategories = (row: string) => {
    showConfirmationDialog({
      title: "Hands Up",
      text: "Are you sure want to change status of this ExpenseCategories ?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          changeStatusExpenseCategories({ id: row }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

const moduleName = "EXPENSE_CATEGORY";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const columns: columnTypes[] = [
  { field: 'expenseCategoryName', headerName: 'Expense Categories Name', flex: 'flex-[1_1_0%]' },
  {
    field: "action",
    headerName: "Actions",
    flex: "flex-[1_1_0%]",
    align:"center",
    extraClasses: "",
    renderCell: (row: any) => {
      const options = [];

      if (canEdit) {
        options.push({
          label: "Edit",
          onClick: () => {
            dispatch(setIsOpenEditDialog(true));
            setSelectedExpenseCategoriesId(row?._id);
          },
        });
      }

      if (canActive) {
        options.push({
          label: "Active/Deactive",
          onClick: () => {
            handleChangeStatusExpenseCategories(row?._id);
          },
        });
      }

      if (canDelete) {
        options.push({
          label: "Delete",
          onClick: () => {
            handleDeleteExpenseCategories(row?._id);
          },
        });
      }

      return <ATMMenu options={options} />;
    },
  },
];


  return (
    <>
      <div>
        <ExpenseCategoriesListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddExpenseCategoriesWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      ) : null}
      {isOpenEditDialog ? (
        <EditExpenseCategoriesWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedExpenseCategoriesId={selectedExpenseCategoriesId || ""}

        />
      ) : null}
    </>
  );
};

export default ExpenseCategoriesListingWrapper;